import { render, staticRenderFns } from "./DocumentCounter.component.pug?vue&type=template&id=caafda76&scoped=true&lang=pug&"
import script from "./DocumentCounter.component.ts?vue&type=script&lang=ts&"
export * from "./DocumentCounter.component.ts?vue&type=script&lang=ts&"
import style0 from "./DocumentCounter.component.scss?vue&type=style&index=0&id=caafda76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caafda76",
  null
  
)

export default component.exports